function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useValidation from './useValidation';
import RadioList from './radio-list';
var SboPackageOptions = function SboPackageOptions(props) {
  var _useState = useState(new Set()),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOptions = _useState2[0],
    setSelectedOptions = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    hasLion = _useState4[0],
    setHasLion = _useState4[1];
  var setIsRush = props.setIsRush,
    handleIsLion = props.handleIsLion,
    showErrors = props.showErrors,
    handleValidationChange = props.handleValidationChange;
  var validations = {
    hasLion: {
      required: {
        value: true,
        message: '*required'
      }
    }
  };
  var _useValidation = useValidation(validations),
    _useValidation2 = _slicedToArray(_useValidation, 3),
    validator = _useValidation2[0],
    validationErrors = _useValidation2[1],
    isValid = _useValidation2[2];

  /**
   * sets our validation function to validate any fields we require on change
   */
  useEffect(function () {
    validator({
      hasLion: hasLion
    });
  }, [hasLion]);

  /**
   * set our global validation with our updated one.
   */
  useEffect(function () {
    handleValidationChange({
      key: 'package-options',
      value: isValid
    });
  }, [isValid]);
  var handleSelectedOptionsChange = function handleSelectedOptionsChange(id) {
    var newSet = new Set(selectedOptions);
    if (selectedOptions.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    setSelectedOptions(newSet);
    setIsRush(newSet.has(id));
  };
  useEffect(function () {
    handleIsLion(hasLion === 'yes');
  }, [hasLion]);
  var errMsgClass = showErrors && !isValid ? 'error' : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "section package-options"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Rush order"), /*#__PURE__*/React.createElement("div", {
    className: "options"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-options"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: function onChange() {
      return handleSelectedOptionsChange('rush');
    },
    id: "rush",
    checked: selectedOptions.has('rush')
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "rush",
    className: "options-label"
  }, "Package contains a rush order", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "\xA0"))))), /*#__PURE__*/React.createElement("div", {
    className: "battery-options"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "has-lion-battery"
  }, "Does your package contain Lithium-ion battery? ", /*#__PURE__*/React.createElement("span", {
    className: "required ".concat(errMsgClass)
  }, "*required")), /*#__PURE__*/React.createElement(RadioList, {
    id: "has-lion-battery",
    label: "",
    items: [{
      text: 'Yes',
      value: 'yes'
    }, {
      text: 'No',
      value: 'no'
    }],
    selectedValue: hasLion,
    onValueChange: function onValueChange(e) {
      setHasLion(e.target.value);
    },
    hasError: !isValid && showErrors
  })));
};
SboPackageOptions.propTypes = {
  setIsRush: PropTypes.func,
  handleIsLion: PropTypes.func,
  handleValidationChange: PropTypes.func,
  showErrors: PropTypes.bool
};
SboPackageOptions.defaultProps = {
  setIsRush: function setIsRush() {},
  handleIsLion: function handleIsLion() {},
  handleValidationChange: function handleValidationChange() {},
  showErrors: false
};
export default SboPackageOptions;